import { queryOptions } from '@tanstack/react-query';
import * as notificationsApi from '../endpoints/notifications';
import { NotificationsData } from '@/types/display';

export const NOTIFICATIONS_QUERY_KEYS = {
  all: ['notifications'] as const,
  list: () => [...NOTIFICATIONS_QUERY_KEYS.all, 'list'] as const,
  unreadCount: () => [...NOTIFICATIONS_QUERY_KEYS.all, 'unread-count'] as const,
} as const;

/**
 * Domain-oriented query options for notifications
 */

export const notificationsQueryOptions = () =>
  queryOptions({
    queryKey: NOTIFICATIONS_QUERY_KEYS.list(),
    queryFn: async (): Promise<NotificationsData> => {
      return notificationsApi.getNotifications();
    },
    staleTime: 60_000, // 1 minute
    gcTime: 1000 * 60 * 10, // 10 minutes
    refetchInterval: 300_000, // 5 min fallback (real-time via WebSocket)
    // Persist alongside the unread count so the list -- not just the badge --
    // paints from disk on cold boot. Purged on logout.
    meta: { persist: true },
  });

/**
 * Query options for unread notifications count
 */
export const unreadCountQueryOptions = () =>
  queryOptions({
    queryKey: NOTIFICATIONS_QUERY_KEYS.unreadCount(),
    queryFn: async (): Promise<number> => {
      return notificationsApi.getUnreadCount();
    },
    staleTime: 60_000, // 1 minute
    gcTime: 1000 * 60 * 5, // 5 minutes
    refetchInterval: 300_000, // 5 min fallback (real-time via WebSocket)
    meta: { persist: true },
  });
